// Runtime configuration for the shared package. Each app calls `configureShared`
// once at startup (mobile: app/_layout.js from EXPO_PUBLIC_*, www: gatsby-browser.js
// from gatsby-env-variables) so this package never reads platform env vars itself.

const config = {
  apiBaseUrl: '',
  geoBaseUrl: '',
  tripPlanningEndpoint: '',
  travelerProfileBuilderEndpoint: '',
  tripActivityActionsEndpoint: '',
  // www consumes the unauthenticated `/public/...` routes
  publicApi: false,
  // affiliate ids for booking deep links (see tripPlanner/bookingLinks.js)
  affiliates: {},
};

export const configureShared = (partial = {}) => {
  Object.entries(partial).forEach(([key, value]) => {
    if (value !== undefined && key in config) config[key] = value;
  });
  return { ...config };
};

export const getSharedConfig = () => ({ ...config });

const trimSlashes = (s) => String(s || '').replace(/^\/+|\/+$/g, '');

/** Absolute API URL for a resource path, honouring the public-route prefix. */
export const apiUrl = (path = '') => {
  const base = trimSlashes(config.apiBaseUrl);
  const prefix = config.publicApi ? 'public/' : '';
  return `${base}/${prefix}${trimSlashes(path)}`;
};

/** Absolute URL of an always-public route (`/public/...`), whatever `publicApi` says. */
export const publicApiUrl = (path = '') => `${trimSlashes(config.apiBaseUrl)}/public/${trimSlashes(path)}`;

export const geoUrl = (path = '') => `${trimSlashes(config.geoBaseUrl)}/${trimSlashes(path)}`;
